// users actionTypes
import lookupUtility from "../Common/Utility/LookUpDataMapping";
import { showLoading, hideLoading } from "react-redux-loading-bar";
// export const FETCH_USERS_BEGIN = "FETCH_USERS_BEGIN";
// export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
// export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_LOOKUP_DATA = "GET_LOOKUP_DATA";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_SELECTED_USERS = "GET_SELECTED_USERS";
export const GET_USER_LOOKUPS = "GET_USER_LOOKUPS";
export const POST_USER_DETAILS = "POST_USER_DETAILS";
export const PUT_USER_DETAILS = "PUT_USER_DETAILS";
export const CHANGE_STATUS = "CHANGE_STATUS";
export const GRID_UPDATE = "GRID_UPDATE";
export const BULK_UPDATE_USERS = "BULK_UPDATE_USERS";
export const EXPORT_TO_EXCEL = "EXPORT_TO_EXCEL";
export const ENABLE_DISABLE_USERS = "ENABLE_DISABLE_USERS";
export const REFRESH_GRID_DATA = "REFRESH_GRID_DATA";
export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS";
export const SHOW_MODAL_TO_DISCARD = "SHOW_MODAL_TO_DISCARD";
export const SHOW_FILTER_ICON = "SHOW_FILTER_ICON";
export const CLEAR_SELECTED_USERS = "CLEAR_SELECTED_USERS";
export const DISCARD_CHANGES_YES = "DISCARD_CHANGES_YES";
export const ROWS_COUNT_AFTER_FILTER = "ROWS_COUNT_AFTER_FILTER";
export const SORT_SELECTED_USERS = "SORT_SELECTED_USERS";
export const CLEAR_ALL_USERS = "CLEAR_ALL_USERS";
export const RESET_LOADING = "RESET_LOADING";
export const MYCALENDER_BUCKET = "MYCALENDER_BUCKET";
export const GET_STAFF_REPORT_DATA = "GET_STAFF_REPORT_DATA";
export const GET_STAFF_LOOKUP_DATA = "GET_STAFF_LOOKUP_DATA";
export const GET_FIRM_LOOKUP_DATA = "GET_FIRM_LOOKUP_DATA";
export const UPDATE_GRACEPERIOD_DATA = "UPDATE_GRACEPERIOD_DATA";
export const GET_FIRM_GRACEPERIOD_DATA = "GET_FIRM_GRACEPERIOD_DATA";
export const GET_STAFF_INTPH_DATA = "GET_STAFF_INTPH_DATA";
export const GET_LICENSE_DATA = "GET_LICENSE_DATA";





// Notification action types
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
